import styled from 'styled-components'

import { RewardsCard } from '../RewardsCard'

export const Card = styled(RewardsCard)`
  align-items: flex-start;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.coolGray.cool100};
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 11px;
  margin: 23px 0 23px 0;

  @media (min-width: 1024px) {
    margin: 0;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const Amount = styled.p`
  line-height: 30px;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 0;
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme }) => theme.colors.brand.blue};
`

export const Text = styled.p`
  font-size: 12px;
  margin-bottom: 0;
  font-family: ${({ theme }) => theme.fonts.global.body};
  color: ${({ theme }) => theme.colors.neutralGray.neutral500};
`
